module.exports = __webpack_public_path__ + "static/media/CeraPro-Black.80f57176.ttf";